import React from "react";
import { ShadcnButton } from "@components/items/display/ShadcnButton";
import TranslatedText from "@components/items/display/TranslatedText";
import { TabResponsibility } from "@wajeez/wajeez.microservices/dist/api.Server.clients";
import { useNavigateToTab } from "@utils/hooks/useNavigateToHome";

const EmptyCertificate = () => {
  const navigateToB2BSkills = useNavigateToTab(TabResponsibility.B2BSkills);
  return (
    <div className="flex w-full flex-col items-center justify-center gap-y-4 self-center py-5">
      <div className="h-[242px] w-[400px] bg-[#D9D9D9]" />
      <TranslatedText
        text={`my-corner-b2b.${"collect your valuable certificates now"}`}
        className="text-[32px] font-bold text-navy-blue dark:text-white"
      />
      <TranslatedText
        text={`my-corner-b2b.${"challenge yourself and enrich your knowledge and experience with content from unique books"}`}
        className="text-[16px] font-medium text-[#898A8D]"
      />
      <ShadcnButton
        className="bg-navy-blue hover:bg-navy-blue/85"
        onClick={navigateToB2BSkills}
      >
        <TranslatedText
          text={`my-corner-b2b.${"start a skill now"}`}
          className="text-[17px] font-medium text-white"
        />
      </ShadcnButton>
    </div>
  );
};

export default EmptyCertificate;
